
import {ApiService, events} from "../../utils/pixiApp";

export function listener(event) {
    event.source.postMessage(JSON.stringify({type: 'load', data: event.data}), {targetOrigin: '*'})
}

export function InitPostMessage() {
   if(typeof window !== 'undefined') {
       if (window.addEventListener) {
           window.addEventListener("message", listener);
       }
   }
}

export const PostMessagesTypes =  {
    LOAD: 'load',
    REFRESH_TOKEN: 'refresh_token',
    REFRESHED_TOKEN: 'refreshed_token',
    GAME_TOUR: 'gameTour',
    REDIRECT: 'REDIRECT',
    STARTED_APP: 'started_app',
}

class PostMessageServiceClass {
    targetOrigin = '*';

    postMessage(data) {
        window.parent.postMessage(
            typeof data === 'object' ? JSON.stringify(data) : data,
            this.targetOrigin,
        );
    }

    async parentMessageListener(eventHasJSON) {
        const event =
            typeof eventHasJSON?.data === 'string'
                ? JSON.parse(eventHasJSON.data)
                : eventHasJSON;

        if(event.type === PostMessagesTypes.LOAD) {
            await ApiService.setTokenFromParent(event.data.token);
            PostMessageService.RemovePostMessageListening();
            events.emitLoadToken()
        }
        if (
            event.type === PostMessagesTypes.REFRESHED_TOKEN
        ) {
            await ApiService.setTokenFromParent(event.data.data);
        }
    }

    ListenPostMessage(init = false) {
        if(init) {
            ApiService.removeToken();
        }
        if (typeof window !== 'undefined') {
            if (window.addEventListener) {
                window.addEventListener('message', this.parentMessageListener);
            } else {
                window.attachEvent('onmessage', this.parentMessageListener);
            }
        }
    }

    RemovePostMessageListening() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('message', this.parentMessageListener);
        }
    }
}
export const PostMessageService = new PostMessageServiceClass();
